import PropTypes                   from "prop-types";
import React                       from "react";
import VXButton                    from "../SimpleElements/VXButton/VXButton";
import {VXButtonLineConfig}        from "../SimpleElements/VXButton/VXButtonConfig";
import {COLOR_TYPE_CALL_TO_ACTION} from "../SimpleElements/VXButton/ButtonHelper";
import {VXPay}                     from "../../utils/VXPay";
import VXButtonOutline             from "../SimpleElements/VXButton/Presets/VXButtonOutline";

class FeedLoginSignup extends React.PureComponent {
	render() {
		return <div>
			<span className={"h-disp-inline-block h-mr-20 h-mb-30"}>
				<VXButton
					line1={this.props.signupText}
					color={COLOR_TYPE_CALL_TO_ACTION}
					onClick={VXPay.openSignup}
					icon={"-icon-user-full"}
				/>
			</span>
			<span>
				<VXButtonOutline
					line1={this.props.loginText}
					onClick={VXPay.openLogin}
					icon={"-icon-user-full"}
				/>
			</span>
		</div>;
	}
}

FeedLoginSignup.propTypes = {
	loginText:  PropTypes.arrayOf(VXButtonLineConfig),
	signupText: PropTypes.arrayOf(VXButtonLineConfig),
};


export default FeedLoginSignup;
